export const translation = {
  zenit: {
    ae: {
      siteTitle: "مكافآتك | Zenit",
      spinBtnTitle: "أدر",
      title: "فز بمكافأة!",
      rulesBtnText: "الشروط والأحكام",
      modal: {
        title: "الرهان الفائز!",
        bonusTitle: "مكافأة",
        bonusText: `100%
          من قيمة إيداعك`,
        getBtnText: "احصل على مكافأتك",
        rulesBtnText: "الشروط والأحكام",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    bn: {
      siteTitle: "আপনার বোনাস | Zenit",
      spinBtnTitle: "স্পিন",
      title: "একটি বোনাস জিতুন!",
      rulesBtnText: "শর্তাবলী",
      modal: {
        title: "বিজয়ী বাজি!",
        bonusTitle: "বোনাস",
        bonusText: `100%
         আপনার আমানতের`,
        getBtnText: "আপনার বোনাস পান",
        rulesBtnText: "শর্তাবলী",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    br: {
      siteTitle: "Seus bônus | Zenit",
      spinBtnTitle: "Girar",
      title: "Fature um bônus!",
      rulesBtnText: "Regras",
      modal: {
        title: "Aposta vencedora!",
        bonusTitle: "Bônus",
        bonusText: `100%
         para seu depósito`,
        getBtnText: "Colete seu bônus",
        rulesBtnText: "Regras",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    de: {
      siteTitle: "Ihre Boni | Zenit",
      spinBtnTitle: "Drehen",
      title: "Gewinnen Sie einen Bonus!",
      rulesBtnText: "Regeln",
      modal: {
        title: "Gewinnende Wette!",
        bonusTitle: "BONUS",
        bonusText: `100%
         auf Ihre Einzahlung`,
        getBtnText: "Holen Sie sich Ihren Bonus",
        rulesBtnText: "Regeln",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    en: {
      siteTitle: "Your bonuses | Zenit",
      spinBtnTitle: "Spin",
      title: "Win a bonus!",
      rulesBtnText: "Rules",
      modal: {
        title: "Winning bet",
        bonusTitle: "BONUS",
        bonusText: `100%
         to your deposit`,
        getBtnText: "Get your bonus",
        rulesBtnText: "Rules",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    fr: {
      siteTitle: "Vos bonus | Zenit",
      spinBtnTitle: "Tourner",
      title: "Gagner un bonus!",
      rulesBtnText: "Conditions générales",
      modal: {
        title: "Pari gagnant!",
        bonusTitle: "BONUS",
        bonusText: `100%
         de votre dépôt`,
        getBtnText: "Obtenir votre bonus",
        rulesBtnText: "Conditions générales",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ir: {
      siteTitle: "برنده جک‌پات شو | کازینو | ZENIT",
      spinBtnTitle: "بچرخ",
      title: "پاداش ببر!",
      rulesBtnText: "قوانین",
      modal: {
        title: "شرط برنده!",
        bonusTitle: "پاداش",
        bonusText: `۱۰۰ درصد
         واریزی شما`,
        getBtnText: "پاداشت رو بگیر",
        rulesBtnText: "قوانین",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    kz: {
      siteTitle20: "Джекпотты ұтып ал | Казино | ZENIT",
      siteTitle25: "Бастапқы бонус | ZENIT БК",
      spinBtnTitle: "Айналдыру",
      title: "Бонус ұтып ал!",
      rulesBtnText: "Ережелер",
      modal: {
        title: "Жеңіс!",
        bonusTitle: "БОНУС",
        bonusText: `Депозитке
         100%`,
        getBtnText: "Бонусты алу",
        rulesBtnText: "Ережелер",
        footnoteText: '*подробнее в Правилах',
      }
    },
    mx: {
      siteTitle: "Sus bonificaciones | Zenit",
      spinBtnTitle: "Gire",
      title: "¡Gane una bonificación!",
      rulesBtnText: "Reglas",
      modal: {
        title: "¡Apuesta ganadora!",
        bonusTitle: "BONIFICACIÓN DE",
        bonusText: `100%
          a su depósito`,
        getBtnText: "Obtenga su bonificación",
        rulesBtnText: "Reglas",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ru: {
      siteTitle20: "Выиграй бонус | ZENIT",
      siteTitle25: "Крути барабан и забирай бонус | ZENIT",
      spinBtnTitle: "Вращать",
      title: "Выиграй бонус!",
      rulesBtnText: "Правила",
      modal: {
        title: "Победа!",
        bonusTitle: "Бонус",
        bonusText: `100%
         на депозит`,
        getBtnText: "Забрать бонус",
        rulesBtnText: "Правила",
        footnoteText: '*подробнее в Правилах',
      }
    },
    sw: {
      siteTitle: "Bonasi zako | Zenit",
      spinBtnTitle: "Zungusha",
      title: "Jishindie bonasi!",
      rulesBtnText: "SHERIA NA\xA0MASHARTI",
      modal: {
        title: "Dau inayoshinda!",
        bonusTitle: "BONASI",
        bonusText: `100%
         kwenye pesa ulizoweka`,
        getBtnText: "Pokea bonasi yako",
        rulesBtnText: "SHERIA NA\xA0MASHARTI",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    tr: {
      siteTitle: "Bonuslarınız | Zenit",
      spinBtnTitle: "Çevir",
      title: "Bir bonus kazanın!",
      rulesBtnText: "HÜKÜM VE KOŞULLAR",
      modal: {
        title: "Kazanan bahis!",
        bonusTitle: "BONUS",
        bonusText: `yatırdığınız paraya
          % 100`,
        getBtnText: "Bonusunuzu alın",
        rulesBtnText: "HÜKÜM VE KOŞULLAR",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ua: {
      siteTitle20: "Сорви джекпот | Казино | ZENIT",
      siteTitle25: "Крути барабан и выигрывай бонус | БК ZENIT",
      spinBtnTitle: "Вращать",
      title: "Выиграй бонус!",
      rulesBtnText: "Правила",
      modal: {
        title: "Победа!",
        bonusTitle: "Бонус",
        bonusText: `100%
         на депозит`,
        getBtnText: "Забрать бонус",
        rulesBtnText: "Правила",
        footnoteText: '*подробнее в Правилах',
      }
    },
    uz: {
      siteTitle: "Bonuslaring | Zenit",
      spinBtnTitle: "Aylantirish",
      title: "Bonus yut!",
      rulesBtnText: "Qoidalar",
      modal: {
        title: "G‘alaba!",
        bonusTitle: "BONUS",
        bonusText: `Depozitga 
         100%`,
        getBtnText: "Bonus olish",
        rulesBtnText: "Qoidalar",
        footnoteText: '*подробнее в Правилах',
      }
    },
    vi: {
      siteTitle: "Tiền thưởng của bạn | Zenit",
      spinBtnTitle: "Quay",
      title: "Nhận phần thưởng!",
      rulesBtnText: "Điều khoản và\xA0điều\xA0kiện",
      modal: {
        title: "Cược chiến thắng!",
        bonusTitle: "TIỀN THƯỞNG",
        bonusText: `100%
         vào khoản tiền nạp của bạn`,
        getBtnText: "Nhận tiền thưởng",
        rulesBtnText: "Điều khoản và\xA0điều\xA0kiện",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    }
  },
  zenbet: {
    ae: {
      siteTitle: "مكافآتك | «ZENBET»",
      spinBtnTitle: "أدر",
      title: "فز بمكافأة!",
      rulesBtnText: "القواعد",
      modal: {
        title: "الرهان الفائز!",
        bonusTitle: "مكافأة",
        bonusText: `100%
          من قيمة إيداعك`,
        getBtnText: "احصل على مكافأتك",
        rulesBtnText: "الشروط والأحكام",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    bn: {
      siteTitle: "আপনার বোনাস | «ZENBET»",
      spinBtnTitle: "স্পিন",
      title: "একটি বোনাস জিতুন!",
      rulesBtnText: "শর্তাবলী",
      modal: {
        title: "বিজয়ী বাজি!",
        bonusTitle: "বোনাস",
        bonusText: `100%
         আপনার আমানতের`,
        getBtnText: "আপনার বোনাস পান",
        rulesBtnText: "শর্তাবলী",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    br: {
      siteTitle20: "Fature o jackpot | Cassino | «ZENBET»",
      siteTitle25: "Bônus de boas-vindas | Bookmaker «ZENBET»",
      spinBtnTitle: "Girar",
      title: "Fature um bônus!",
      rulesBtnText: "Regras",
      modal: {
        title: "Aposta vencedora!",
        bonusTitle: "Bônus",
        bonusText: `100%
         para seu depósito`,
        getBtnText: "Colete seu bônus",
        rulesBtnText: "Regras",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    de: {
      siteTitle: "Ihre Boni | «ZENBET»",
      spinBtnTitle: "Drehen",
      title: "Gewinnen Sie einen Bonus!",
      rulesBtnText: "Regeln",
      modal: {
        title: "Gewinnende Wette!",
        bonusTitle: "BONUS",
        bonusText: `100%
         auf Ihre Einzahlung`,
        getBtnText: "Holen Sie sich Ihren Bonus",
        rulesBtnText: "Regeln",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    en: {
      siteTitle20: "Jackpot | Casino | «ZENBET»",
      siteTitle25: "Welcome bonus | «ZENBET»",
      spinBtnTitle: "Spin",
      title: "Win a bonus!",
      rulesBtnText: "Rules",
      modal: {
        title: "Winning bet",
        bonusTitle: "BONUS",
        bonusText: `100%
         to your deposit`,
        getBtnText: "Get your bonus",
        rulesBtnText: "Rules",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    fr: {
      siteTitle: "Vos bonus | «ZENBET»",
      spinBtnTitle: "Tourner",
      title: "Gagner un bonus!",
      rulesBtnText: "Conditions générales",
      modal: {
        title: "Pari gagnant!",
        bonusTitle: "BONUS",
        bonusText: `100%
         de votre dépôt`,
        getBtnText: "Obtenir votre bonus",
        rulesBtnText: "Conditions générales",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ir: {
      siteTitle: "برنده جک‌پات شو | کازینو | «ZENBET»",
      spinBtnTitle: "بچرخ",
      title: "پاداش ببر!",
      rulesBtnText: "قوانین",
      modal: {
        title: "شرط برنده!",
        bonusTitle: "پاداش",
        bonusText: `۱۰۰ درصد
         واریزی شما`,
        getBtnText: "پاداشت رو بگیر",
        rulesBtnText: "قوانین",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    kz: {
      siteTitle: "Сенің бонустарың | БК «ZENBET»",
      spinBtnTitle: "Айналдыру",
      title: "Бонус ұтып ал!",
      rulesBtnText: "Ережелер",
      modal: {
        title: "Жеңіс!",
        bonusTitle: "БОНУС",
        bonusText: `Депозитке
         100%`,
        getBtnText: "Бонусты алу",
        rulesBtnText: "Ережелер",
        footnoteText: '*подробнее в Правилах',
      }
    },
    mx: {
      siteTitle20: "Hágase con el premio gordo | Casino | «ZENBET»",
      siteTitle25: "Bonificación de bienvenida | Bookmaker «ZENBET»",
      spinBtnTitle: "Gire",
      title: "¡Gane una bonificación!",
      rulesBtnText: "Reglas",
      modal: {
        title: "¡Apuesta ganadora!",
        bonusTitle: "BONIFICACIÓN DE",
        bonusText: `100%
          a su depósito`,
        getBtnText: "Obtenga su bonificación",
        rulesBtnText: "Reglas",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ru: {
      siteTitle: "Твои бонусы | БК «ZENBET»",
      spinBtnTitle: "Вращать",
      title: "Выиграй бонус!",
      rulesBtnText: "Правила",
      modal: {
        title: "Победа!",
        bonusTitle: "Бонус",
        bonusText: `100%
         на депозит`,
        getBtnText: "Забрать бонус",
        rulesBtnText: "Правила",
        footnoteText: '*подробнее в Правилах',
      }
    },
    sw: {
      siteTitle: "Bonasi zako | «ZENBET»",
      spinBtnTitle: "Zungusha",
      title: "Jishindie bonasi!",
      rulesBtnText: "SHERIA NA\xA0MASHARTI",
      modal: {
        title: "Dau inayoshinda!",
        bonusTitle: "BONASI",
        bonusText: `100%
         kwenye pesa ulizoweka`,
        getBtnText: "Pokea bonasi yako",
        rulesBtnText: "SHERIA NA\xA0MASHARTI",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    tr: {
      siteTitle: "Bonuslarınız | «ZENBET»",
      spinBtnTitle: "Çevir",
      title: "Bir bonus kazanın!",
      rulesBtnText: "HÜKÜM VE KOŞULLAR",
      modal: {
        title: "Kazanan bahis!",
        bonusTitle: "BONUS",
        bonusText: `yatırdığınız paraya
          % 100`,
        getBtnText: "Bonusunuzu alın",
        rulesBtnText: "HÜKÜM VE KOŞULLAR",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    uz: {
      siteTitle: "Bonuslaring | «ZENBET»",
      spinBtnTitle: "Aylantirish",
      title: "Bonus yut!",
      rulesBtnText: "Qoidalar",
      modal: {
        title: "G‘alaba!",
        bonusTitle: "BONUS",
        bonusText: `Depozitga 
         100%`,
        getBtnText: "Bonus olish",
        rulesBtnText: "Qoidalar",
        footnoteText: '*подробнее в Правилах',
      }
    },
    vi: {
      siteTitle: "Tiền thưởng của bạn | «ZENBET»",
      spinBtnTitle: "Quay",
      title: "Nhận phần thưởng!",
      rulesBtnText: "Điều khoản và\xA0điều\xA0kiện",
      modal: {
        title: "Cược chiến thắng!",
        bonusTitle: "TIỀN THƯỞNG",
        bonusText: `100%
         vào khoản tiền nạp của bạn`,
        getBtnText: "Nhận tiền thưởng",
        rulesBtnText: "Điều khoản và\xA0điều\xA0kiện",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    }
  }
}